const types = {
  CHANGE_LAYOUT: 'CHANGE_LAYOUT',
  SET_VALUE: 'SET_VALUE',
  SET_FONT_SIZE: 'SET_FONT_SIZE',
  SET_IMAGE: 'SET_IMAGE',
  SET_BACKUP_IMAGE: 'SET_BACKUP_IMAGE',
  CHANGE_AMOUNT: 'CHANGE_AMOUNT'
};

export default types;